export default {
  "aa": {"name": "Afar", "flag": "dj"},
  "ab": {"name": "Аҧсуа бызшәа", "flag": "ge"},
  "af": {"name": "Afrikaans", "flag": "za"},
  "ak": {"name": "Akan", "flag": "gh"},
  "sq": {"name": "Shqip", "flag": "al"},
  "am": {"name": "አማርኛ", "flag": "et"},
  "ar": {"name": "العربية", "flag": "sa"},
  "an": {"name": "Aragonés", "flag": "es"},
  "hy": {"name": "Հայերեն", "flag": "am"},
  "as": {"name": "অসমীয়া", "flag": "in"},
  "av": {"name": "Авар мацӀ", "flag": "ru"},
  "ae": {"name": "Avesta", "flag": "ir"},
  "ay": {"name": "Aymar aru", "flag": "bo"},
  "az": {"name": "Azərbaycan dili", "flag": "az"},
  "bm": {"name": "Bamanankan", "flag": "ml"},
  "ba": {"name": "Башҡорт теле", "flag": "ru"},
  "eu": {"name": "Euskara", "flag": "es"},
  "be": {"name": "Беларуская мова", "flag": "by"},
  "bn": {"name": "বাংলা", "flag": "bd"},
  "bh": {"name": "भोजपुरी", "flag": "in"},
  "bi": {"name": "Bislama", "flag": "vu"},
  "bs": {"name": "Bosanski jezik", "flag": "ba"},
  "br": {"name": "Brezhoneg", "flag": "fr"},
  "bg": {"name": "Български език", "flag": "bg"},
  "my": {"name": "ဗမာစာ", "flag": "mm"},
  "ca": {"name": "Català", "flag": "ad"},
  "ch": {"name": "Chamoru", "flag": "gu"},
  "ce": {"name": "Нохчийн мотт", "flag": "ru"},
  "ny": {"name": "ChiCheŵa", "flag": "mw"},
  "zh": {"name": "中文", "flag": "cn"},
  "cv": {"name": "Чӑваш чӗлхи", "flag": "ru"},
  "kw": {"name": "Kernewek", "flag": "gb"},
  "co": {"name": "Corsu", "flag": "fr"},
  "cr": {"name": "ᓀᐦᐃᔭᐍᐏᐣ", "flag": "ca"},
  "hr": {"name": "Hrvatski jezik", "flag": "hr"},
  "cs": {"name": "Čeština", "flag": "cz"},
  "da": {"name": "Dansk", "flag": "dk"},
  "dv": {"name": "ދިވެހި", "flag": "mv"},
  "nl": {"name": "Nederlands", "flag": "nl"},
  "dz": {"name": "རྫོང་ཁ", "flag": "bt"},
  "en": {"name": "English", "flag": "gb"},
  "eo": {"name": "Esperanto", "flag": "eu"},
  "et": {"name": "Eesti", "flag": "ee"},
  "ee": {"name": "Eʋegbe", "flag": "gh"},
  "fo": {"name": "Føroyskt", "flag": "fo"},
  "fj": {"name": "Vosa Vakaviti", "flag": "fj"},
  "fi": {"name": "Suomi", "flag": "fi"},
  "fr": {"name": "Français", "flag": "fr"},
  "ff": {"name": "Fulfulde", "flag": "sn"},
  "gl": {"name": "Galego", "flag": "es"},
  "ka": {"name": "Ქართული", "flag": "ge"},
  "de": {"name": "Deutsch", "flag": "de"},
  "el": {"name": "Ελληνικά", "flag": "gr"},
  "gn": {"name": "Avañe'ẽ", "flag": "py"},
  "gu": {"name": "ગુજરાતી", "flag": "in"},
  "ht": {"name": "Kreyòl ayisyen", "flag": "ht"},
  "ha": {"name": "هَوُسَ", "flag": "ng"},
  "he": {"name": "עברית", "flag": "il"},
  "hz": {"name": "Otjiherero", "flag": "na"},
  "hi": {"name": "हिन्दी", "flag": "in"},
  "ho": {"name": "Hiri Motu", "flag": "pg"},
  "hu": {"name": "Magyar", "flag": "hu"},
  "ia": {"name": "Interlingua", "flag": "us"},
  "id": {"name": "Bahasa Indonesia", "flag": "id"},
  "ie": {"name": "Interlingue", "flag": "fr"},
  "ga": {"name": "Gaeilge", "flag": "ie"},
  "ig": {"name": "Asụsụ Igbo", "flag": "ng"},
  "ik": {"name": "Iñupiaq", "flag": "us"},
  "io": {"name": "Ido", "flag": "io"},
  "is": {"name": "Íslenska", "flag": "is"},
  "it": {"name": "Italiano", "flag": "it"},
  "iu": {"name": "ᐃᓄᒃᑎᑐᑦ", "flag": "ca"},
  "ja": {"name": "日本語", "flag": "jp"},
  "jv": {"name": "Basa Jawa", "flag": "id"},
  "kl": {"name": "Kalaallisut", "flag": "gl"},
  "kn": {"name": "ಕನ್ನಡ", "flag": "in"},
  "kr": {"name": "Kanuri", "flag": "ng"},
  "ks": {"name": "कश्मीरी", "flag": "in"},
  "kk": {"name": "Қазақ тілі", "flag": "kz"},
  "km": {"name": "ភាសាខ្មែរ", "flag": "kh"},
  "ki": {"name": "Gĩkũyũ", "flag": "ke"},
  "rw": {"name": "Ikinyarwanda", "flag": "rw"},
  "ky": {"name": "Кыргыз тили", "flag": "kg"},
  "kv": {"name": "Коми кыв", "flag": "ru"},
  "kg": {"name": "KiKongo", "flag": "cd"},
  "ko": {"name": "한국어", "flag": "kr"},
  "ku": {"name": "Kurdî", "flag": "iq"},
  "kj": {"name": "Kuanyama", "flag": "na"},
  "la": {"name": "Latin", "flag": "va"},
  "lb": {"name": "Lëtzebuergesch", "flag": "lu"},
  "lg": {"name": "Luganda", "flag": "ug"},
  "li": {"name": "Limburgs", "flag": "nl"},
  "ln": {"name": "Lingála", "flag": "cd"},
  "lo": {"name": "ພາສາລາວ", "flag": "la"},
  "lt": {"name": "Lietuvių kalba", "flag": "lt"},
  "lu": {"name": "Tshiluba", "flag": "cd"},
  "lv": {"name": "Latviešu valoda", "flag": "lv"},
  "gv": {"name": "Gaelg", "flag": "im"},
  "mk": {"name": "Македонски јазик", "flag": "mk"},
  "mg": {"name": "Fiteny malagasy", "flag": "mg"},
  "ms": {"name": "Bahasa Melayu", "flag": "my"},
  "ml": {"name": "മലയാളം", "flag": "in"},
  "mt": {"name": "Malti", "flag": "mt"},
  "mi": {"name": "Te reo Māori", "flag": "nz"},
  "mr": {"name": "मराठी", "flag": "in"},
  "mh": {"name": "Kajin M̧ajeļ", "flag": "mh"},
  "mn": {"name": "Монгол хэл", "flag": "mn"},
  "na": {"name": "Ekakairũ Naoero", "flag": "nr"},
  "nv": {"name": "Diné bizaad", "flag": "us"},
  "nd": {"name": "IsiNdebele", "flag": "za"},
  "ne": {"name": "नेपाली", "flag": "np"},
  "ng": {"name": "Owambo", "flag": "na"},
  "nb": {"name": "Norsk bokmål", "flag": "no"},
  "nn": {"name": "Norsk nynorsk", "flag": "no"},
  "no": {"name": "Norsk", "flag": "no"},
  "ii": {"name": "ꆇꉙ", "flag": "cn"},
  "nr": {"name": "IsiNdebele", "flag": "za"},
  "oc": {"name": "Occitan", "flag": "fr"},
  "oj": {"name": "ᐊᓂᔑᓈᐯᒧᐎᓐ", "flag": "ca"},
  "cu": {"name": "Ѩзыкъ словѣньскъ", "flag": "bg"},
  "om": {"name": "Afaan Oromoo", "flag": "et"},
  "or": {"name": "ଓଡ଼ିଆ", "flag": "in"},
  "os": {"name": "Ирон æвзаг", "flag": "ru"},
  "pa": {"name": "ਪੰਜਾਬੀ", "flag": "in"},
  "pi": {"name": "पालि", "flag": "np"},
  "fa": {"name": "فارسی", "flag": "ir"},
  "pl": {"name": "Polski", "flag": "pl"},
  "ps": {"name": "پښتو", "flag": "af"},
  "pt": {"name": "Português", "flag": "pt"},
  "qu": {"name": "Runa Simi", "flag": "pe"},
  "rm": {"name": "Rumantsch grischun", "flag": "ch"},
  "rn": {"name": "Ikirundi", "flag": "bi"},
  "ro": {"name": "Română", "flag": "ro"},
  "ru": {"name": "Русский", "flag": "ru"},
  "sa": {"name": "संस्कृतम्", "flag": "in"},
  "sc": {"name": "Sardu", "flag": "it"},
  "sd": {"name": "सिन्धी", "flag": "pk"},
  "se": {"name": "Davvisámegiella", "flag": "no"},
  "sm": {"name": "Gagana fa'a Samoa", "flag": "ws"},
  "sg": {"name": "Yângâ tî sängö", "flag": "cf"},
  "sr": {"name": "Српски језик", "flag": "rs"},
  "gd": {"name": "Gàidhlig", "flag": "gb"},
  "sn": {"name": "ChiShona", "flag": "zw"},
  "si": {"name": "සිංහල", "flag": "lk"},
  "sk": {"name": "Slovenčina", "flag": "sk"},
  "sl": {"name": "Slovenščina", "flag": "si"},
  "so": {"name": "Soomaaliga", "flag": "so"},
  "st": {"name": "Sesotho", "flag": "ls"},
  "es": {"name": "Español", "flag": "es"},
  "su": {"name": "Basa Sunda", "flag": "id"},
  "sw": {"name": "Kiswahili", "flag": "tz"},
  "ss": {"name": "SiSwati", "flag": "sz"},
  "sv": {"name": "Svenska", "flag": "se"},
  "ta": {"name": "தமிழ்", "flag": "in"},
  "te": {"name": "తెలుగు", "flag": "in"},
  "tg": {"name": "Тоҷикӣ", "flag": "tj"},
  "th": {"name": "ไทย", "flag": "th"},
  "ti": {"name": "ትግርኛ", "flag": "er"},
  "bo": {"name": "བོད་ཡིག", "flag": "cn"},
  "tk": {"name": "Türkmen", "flag": "tm"},
  "tl": {"name": "Tagalog", "flag": "ph"},
  "tn": {"name": "Setswana", "flag": "bw"},
  "to": {"name": "Faka Tonga", "flag": "to"},
  "tr": {"name": "Türkçe", "flag": "tr"},
  "ts": {"name": "Xitsonga", "flag": "za"},
  "tt": {"name": "Татар теле", "flag": "ru"},
  "tw": {"name": "Twi", "flag": "gh"},
  "ty": {"name": "Reo Tahiti", "flag": "pf"},
  "ug": {"name": "ئۇيغۇرچە", "flag": "cn"},
  "uk": {"name": "Українська", "flag": "ua"},
  "ur": {"name": "اردو", "flag": "pk"},
  "uz": {"name": "Oʻzbek", "flag": "uz"},
  "ve": {"name": "Tshivenḓa", "flag": "za"},
  "vi": {"name": "Tiếng Việt", "flag": "vn"},
  "vo": {"name": "Volapük", "flag": "de"},
  "wa": {"name": "Walon", "flag": "be"},
  "cy": {"name": "Cymraeg", "flag": "gb"},
  "wo": {"name": "Wollof", "flag": "sn"},
  "fy": {"name": "Frysk", "flag": "nl"},
  "xh": {"name": "IsiXhosa", "flag": "za"},
  "yi": {"name": "ייִדיש", "flag": "il"},
  "yo": {"name": "Yorùbá", "flag": "ng"},
  "za": {"name": "Saɯ cueŋƅ", "flag": "cn"},
  "zu": {"name": "IsiZulu", "flag": "za"}
}
